// extracted by mini-css-extract-plugin
export default {"Paper":"Paper_Paper__igJm8","PaperGutter":"Paper_PaperGutter__YHu6p"};